import { LineLoading } from "@/components/loading";
import SimpleLayout from "@/layouts/simple";
import { Suspense, lazy } from "react";
import { Outlet, type RouteObject } from "react-router";

const Page403 = lazy(() => import("@/pages/sys/error/Page403"));
const Page404 = lazy(() => import("@/pages/sys/error/Page404"));
const Page500 = lazy(() => import("@/pages/sys/error/Page500"));
const PublicDataRequest = lazy(() => import("@/pages/public-data-request"));
const ComplaintFeedback = lazy(() => import("@/pages/complaint-feedback"));
const PasswordReset = lazy(() => import("@/pages/password-reset"));
// A szerződés online aláírása: az ügyfél e-mailben kapja a linket, belépés nélkül.
// Az oldal megvolt, de az útvonal hiányzott — a link a 404-es oldalra vitt.
const PublicSignContract = lazy(() => import("@/pages/contracts/public-sign"));

export const mainRoutes: RouteObject[] = [
	{
		path: "/",
		element: (
			<SimpleLayout>
				<Suspense fallback={<LineLoading />}>
					<Outlet />
				</Suspense>
			</SimpleLayout>
		),
		children: [
			{ path: "500", element: <Page500 /> },
			{ path: "404", element: <Page404 /> },
			{ path: "403", element: <Page403 /> },
		],
	},
	{
		path: "/adatbekero/:slug",
		element: (
			<Suspense fallback={<LineLoading />}>
				<PublicDataRequest />
			</Suspense>
		),
	},
	{
		path: "/sign-contract/:token",
		element: (
			<Suspense fallback={<LineLoading />}>
				<PublicSignContract />
			</Suspense>
		),
	},
	{
		path: "/complaint-feedback/:token",
		element: (
			<Suspense fallback={<LineLoading />}>
				<ComplaintFeedback />
			</Suspense>
		),
	},
	{
		path: "/reset-password/:token",
		element: (
			<Suspense fallback={<LineLoading />}>
				<PasswordReset />
			</Suspense>
		),
	},
];
